import React from "react";
import { Route, Switch } from "react-router-dom";
import { PostApprovalPlaidProvider } from "../../hooks/usePostApprovalPlaidContext";
import useSessionEntity from "../../hooks/useSessionEntity";
import Loading from "../shared/Loading";
import PostApprovalPlaidOffer from "./post_approval/PostApprovalPlaidOffer";
import PostApprovalPlaidProcessing from "./post_approval/PostApprovalPlaidProcessing";

const PostApprovalPlaidOfferRoute = (props) => (
  <PostApprovalPlaidProvider>
    <PostApprovalPlaidOffer
      {...props}
      renderProcessing={() => <PostApprovalPlaidProcessing />}
    />
  </PostApprovalPlaidProvider>
);

export default function PostApproval({ match }) {
  const merchant = useSessionEntity("merchant");
  const company = useSessionEntity("company");
  const user = useSessionEntity("user");
  const application = useSessionEntity("application");

  if (!merchant || !company || !user || !application) {
    return <Loading className="w-14 h-14" />;
  }

  return (
    <Switch>
      <Route
        exact
        key="offer"
        path={`${match.path}/offer`}
        component={PostApprovalPlaidOfferRoute}
      />
      <Route
        exact
        key="processing"
        path={`${match.path}/processing`}
        component={PostApprovalPlaidOfferRoute}
      />
    </Switch>
  );
}
